import { createTwc } from 'react-twc';

import { cn } from './cn';

export const twx = createTwc({ compose: cn });
